import React from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Layout from "../../layout";
import "../../layout/style.css";
import { useTranslation } from "react-i18next";

function PasswordResetTokenNotValid() {
  const { t } = useTranslation();
  return (
    <Layout>
      <ErrorOutlineIcon className="icon" style={{ color: "red" }} />
      <Layout.Title>{t("generals.tokenHasExpired")}</Layout.Title>
      <Layout.Paragraph>{t("generals.pleaseTryAgain")}</Layout.Paragraph>
    </Layout>
  );
}

export default PasswordResetTokenNotValid;
